interface WorkspaceWithDomain {
	domain: string
	customDomain: string | null
}

export function getPortalBaseUrl(
	workspace: WorkspaceWithDomain | null | undefined,
): string {
	if (!workspace) return "https://productlane.com/"
	if (workspace.domain === "hello") return "https://productlane.com/"
	const host = workspace.customDomain
		? workspace.customDomain
		: `${workspace.domain}.productlane.com`
	return `https://${host}/`
}
